import config    from "../appConfig";
import axios     from 'axios';
import stringify from 'qs/lib/stringify';

let store = null;

const paramsSerializer = ( params ) => stringify(params, { arrayFormat: 'brackets' });
export const setStore = ( _store ) => store = _store;

const api = axios.create({
  baseURL: config.apiUrl,
  paramsSerializer,
});

api.interceptors.request.use(
  config => {
    const token = store.getters['appUser/token'] || store.state.token;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => Promise.reject(error),
);

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        store.dispatch('appUser/LOGOUT');
      }
      if (error.response.status === 503) {
        store.commit('SET_MAINTENANCE', true);
      }
    }
    return Promise.reject(error);
  },
);

export default api;
